import { Card } from '../ui'

/**
 * The last seven days (Sprint 1.9.9 D13): presence, not a streak.
 *
 * A dot per day in the corner's colour where the day has a quadrant the
 * dictionary names, a neutral dot where something was recorded and no corner
 * was, and a hollow ring where nothing was. There is no count, anywhere: a
 * number of days would be the first step toward a streak. Each dot's name is
 * handed in finished, for a screen reader, since colour is never the only
 * channel.
 */
export interface WeekDay {
  date: string
  /** "Thu". */
  label: string
  /** "Sep 10, 2026: Settled", "…: recorded", "…: not recorded". */
  name: string
  kind: 'quadrant' | 'neutral' | 'hollow'
  /** One of the four tokens when `kind` is quadrant, for its colour class. */
  token: string | null
  today: boolean
}

export function LastSevenDays({ days }: { days: readonly WeekDay[] }) {
  return (
    <Card as="article" eyebrow="Last 7 days" className="week">
      <ol className="week__days" data-testid="home-week">
        {days.map((day) => (
          <li className={day.today ? 'week__day week__day--today' : 'week__day'} key={day.date}>
            <span
              className={day.kind === 'quadrant' && day.token !== null
                ? `week__dot week__dot--quadrant mirror-q--${day.token}`
                : `week__dot week__dot--${day.kind}`}
              role="img"
              aria-label={day.name}
            />
            <span className="week__label" aria-hidden="true">{day.label}</span>
          </li>
        ))}
      </ol>
    </Card>
  )
}
